module.exports = __webpack_public_path__ + "static/img/DLD.1fc6feb1.png";